import { render, staticRenderFns } from "./focusPage.vue?vue&type=template&id=03cf4835&scoped=true&"
import script from "./focusPage.vue?vue&type=script&lang=js&"
export * from "./focusPage.vue?vue&type=script&lang=js&"
import style0 from "./focusPage.vue?vue&type=style&index=0&id=03cf4835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cf4835",
  null
  
)

export default component.exports